import { defineStore } from "pinia";

import { usePatientStore } from "@/stores/patientStore";
// * STOREs
import { useStoreWorkList } from "@/stores/workListsStore";

// del API
import {
  fetchAppointments,
  fetchPatientListFromSchedule,
  fetchPatientMasterList,
  fetchTodaysPatientList,
} from "../api/patientApi";

import moment from "moment";
import { extendMoment } from "moment-range";
var moment1 = extendMoment(moment);

// // console.log(" new MOMENT.js");
const currentDate = moment(Date.now()).format("MM/DD/YYYY");
// console.log("User's PATIENT Store =  currentDate : ", currentDate);

import { toast } from "vue3-toastify";

export const useUsersPatientsStore = defineStore("usersPatients", {
  state: () => ({
    patientIDStartList: [
      // 42185, 15225, 27734, 46190, 2714, 40684,
      // 41180, 46605, 45208, 40295, 44955,
      //  9939,
      // 15225, 27734, 46190,
      // 27734,
    ], // users patient Id list

    todaysPatientList: [],
    patientListFromSchedule: [],

    masterPatientList: [],
    unfilteredMasterPatientList: [],

    patientList: [], // this will be the collection of completed Patients

    flatPatientList: [], // this will be the collection of completed Patients
    scheduledPatients: [], // this will be the collection of USERs scheduled Patients

    unassignedScheduledPatients: [], // this will be the MASTER list of unassigned Scheduled Patients

    patientArrayForControls: [],
    id: 0,
    unassignedPatients: [],
    assignedPatients: [],

    appointmentsMaster: [
      {
        text: "THNG 2",
        officeId: 4,
        clinicianId: 4,
        personID: 46637,
        startDate: "2026-04-20T13:00:00Z",
        endDate: "2026-04-20T15:30:00Z",
      },
      {
        text: "SOMETHING 1",
        officeId: 4,
        clinicianId: 5,
        personID: 4805,
        startDate: "2026-04-14T13:00:00Z",
        endDate: "2026-04-14T15:30:00Z",
      },
      {
        text: "TEST 1",
        officeId: 1,
        clinicianId: 2,
        personID: 21140,
        startDate: "2026-04-17T13:00:00.000Z",
        endDate: "2026-04-17T15:30:00.000Z",
      },
      {
        text: "Follow-up Appointment - Jane Smith",
        officeId: 2,
        clinicianId: 1,
        personID: 25908,
        startDate: "2026-04-16T13:00:00.000Z",
        endDate: "2026-04-16T15:30:00.000Z",
      },
      {
        text: "RANDOM TESTING",
        officeId: 3,
        clinicianId: 1,
        personID: 15775,
        startDate: "2026-04-16T19:00:00Z",
        endDate: "2026-04-16T20:00:00Z",
      },
      {
        text: "EoD - Jane Smith",
        officeId: 2,
        clinicianId: 1,
        personID: 25908,
        startDate: "2026-04-17T20:00:00Z",
        endDate: "2026-04-17T21:30:00Z",
      },
      {
        text: "Patient Consultation - John Doe",
        officeId: 1,
        clinicianId: 2,
        personID: 21140,
        startDate: "2026-04-27T16:30:00.000Z",
        endDate: "2026-04-27T18:30:00.000Z",
      },
      {
        text: "Follow-up Appointment - Jane Smith",
        officeId: 2,
        clinicianId: 1,
        personID: 25908,
        startDate: "2026-04-27T19:00:00.000Z",
        endDate: "2026-04-27T20:00:00.000Z",
      },
      {
        text: "Physical Therapy Session - Bob Wilson",
        officeId: 1,
        clinicianId: 3,
        personID: 46637,
        startDate: "2026-04-27T21:30:00.000Z",
        endDate: "2026-04-27T22:30:00.000Z",
      },
      {
        text: "Lab Results Review - Mary Johnson",
        officeId: 3,
        clinicianId: 2,
        personID: 4805,
        startDate: "2026-04-28T17:00:00.000Z",
        endDate: "2026-04-28T18:00:00.000Z",
      },
      {
        text: "Surgery Consultation - David Brown",
        officeId: 2,
        clinicianId: 4,
        personID: 15775,
        startDate: "2026-04-28T19:00:00.000Z",
        endDate: "2026-04-28T20:35:00.000Z",
      },
      {
        text: "Coding Review Session",
        officeId: 1,
        clinicianId: 5,
        personID: 21140,
        startDate: "2026-04-28T21:30:00.000Z",
        endDate: "2026-04-28T22:45:00.000Z",
      },
      {
        allDay: false,
        text: "Becky Does THIIS",
        officeId: 1,
        clinicianId: 6,
        personID: 46637,
        startDate: "2026-05-01T08:00:00.000Z",
        endDate: "2026-05-01T17:00:00.000Z",
      },
      {
        text: "Cod Session #1 8:00 AM local time (UTC-5)",
        officeId: 1,
        clinicianId: 1,
        personID: 21140,
        startDate: "2026-04-30T13:00:00.000Z",
        endDate: "2026-04-30T14:00:00.000Z",
      },
      {
        text: "Cod Session #2 9:00 AM local time (UTC-5)",
        officeId: 1,
        clinicianId: 1,
        personID: 21140,
        startDate: "2026-04-30T14:00:00.000Z",
        endDate: "2026-04-30T15:00:00.000Z",
      },
      {
        text: "Cod Session  #3 1:00 PM local time (UTC-5)",
        officeId: 1,
        clinicianId: 1,
        personID: 21140,
        startDate: "2026-04-30T18:00:00.000Z",
        endDate: "2026-04-30T19:00:00.000Z",
      },
      {
        text: "Cod Session #4 4:00 PM local time (UTC-5)",
        officeId: 1,
        clinicianId: 1,
        personID: 21140,
        startDate: "2026-04-30T21:00:00.000Z",
        endDate: "2026-04-30T21:30:00.000Z",
      },
      {
        text: " Session #1 8:00 AM local time (UTC-5)",
        officeId: 1,
        clinicianId: 2,
        personID: 21140,
        startDate: "2026-04-30T13:00:00.000Z",
        endDate: "2026-04-30T14:00:00.000Z",
      },
      {
        text: " Session #2 9:00 AM local time (UTC-5)",
        officeId: 1,
        clinicianId: 2,
        personID: 21140,
        startDate: "2026-04-30T14:00:00.000Z",
        endDate: "2026-04-30T15:00:00.000Z",
      },
      {
        text: " Session #3 local time (UTC-5)",
        officeId: 1,
        clinicianId: 3,
        personID: 21140,
        startDate: "2026-04-30T14:00:00.000Z",
        endDate: "2026-04-30T15:00:00.000Z",
      },
      {
        text: "Cod Session  #3 1:00 PM local time (UTC-5)",
        officeId: 1,
        clinicianId: 4,
        personID: 27734,
        startDate: "2026-04-30T18:00:00.000Z",
        endDate: "2026-04-30T19:00:00.000Z",
      },
      {
        text: "ZULU Convert",
        officeId: 1,
        clinicianId: 3,
        personID: 27734,
        startDate: "2026-04-30T20:00:00Z",
        endDate: "2026-04-30T21:15:00Z",
      },
      {
        text: "ZULU TEST Convert",
        officeId: 1,
        clinicianId: 3,
        personID: 27734,
        startDate: "2026-04-01T13:00:00Z",
        endDate: "2026-04-01T14:15:00Z",
      },
      {
        text: "22222222 ZULU TEST Convert",
        officeId: 1,
        clinicianId: 5,
        personID: 27734,
        startDate: "2026-04-02T03:22:26-12:00",
        endDate: "2026-04-02T03:22:26-12:00",
      },
      {
        allDay: false,
        text: "test 1",
        description: "test",
        officeId: 1,
        clinicianId: 4,
        personID: 2659,
        startDate: "2026-04-03T13:15:00Z",
        endDate: "2026-04-03T13:30:00Z",
      },
      {
        allDay: false,
        text: "1122",
        officeId: 1,
        clinicianId: 1,
        personID: 25908,
        startDate: "2026-04-03T13:15:00Z",
        endDate: "2026-04-03T13:30:00Z",
      },
      {
        allDay: false,
        text: "sdff",
        officeId: 1,
        clinicianId: 1,
        personID: 45523,
        startDate: "2026-04-03T14:30:00Z",
        endDate: "2026-04-03T15:45:00Z",
      },
      {
        allDay: false,
        text: "Dr",
        officeId: 2,
        clinicianId: 1,
        personID: 2659,
        startDate: "2026-04-08T13:00:00Z",
        endDate: "2026-04-08T16:00:00Z",
      },
      {
        allDay: false,
        text: "DR2",
        officeId: 3,
        clinicianId: 1,
        personID: 45278,
        startDate: "2026-04-09T14:30:00Z",
        endDate: "2026-04-09T14:45:00Z",
      },
      {
        allDay: false,
        text: "dr3",
        officeId: 4,
        clinicianId: 1,
        personID: 45922,
        startDate: "2026-04-10T14:30:00Z",
        endDate: "2026-04-10T14:45:00Z",
      },
      {
        allDay: false,
        text: "33333",
        description: "3333333",
        officeId: 1,
        clinicianId: 1,
        personID: 9794,
        startDate: "2026-04-06T14:30:00Z",
        endDate: "2026-04-06T14:45:00Z",
      },
      {
        allDay: false,
        text: "srt",
        officeId: 1,
        clinicianId: 1,
        personID: 13133,
        startDate: "2026-04-07T15:00:00Z",
        endDate: "2026-04-07T15:15:00Z",
      },
    ] || [],

    testPatientAPPData: [
      {
        allDay: false,
        startDate: new Date("2026-03-31T08:00:00.000Z"),
        endDate: new Date("2026-03-31T11:00:00.000Z"),
        clinicianId: 6,
        officeId: 1,
        personID: 46637,
        text: "Becky Does THIIS",
      },
      // {
      //   text: "New Patient Consultation ",
      //   officeId: 1, // changed from [1] to 1
      //   clinicianId: 1,
      //   startDate: new Date("2026-04-01T08:30:00.000Z"),
      //   endDate: new Date("2026-04-01T09:30:00.000Z"),
      // },
    ],
  }),
  // getters
  // actions
  actions: {
    async loadAppointments() {
      const result = await fetchAppointments();
      if (result.ok && result.payload) {
        this.appointmentsMaster = result.payload;
      }
      return result;
    },
    addAppointment(appointment) {
      this.appointmentsMaster.push({ ...appointment });
      // ADD API CALL to SAVE APPOINTMENT to DB
      console.log(" ***  addAppointment  to Store + API CALL to SAVE APPOINTMENT to DB  *** ");
      console.log(appointment);
      // Save appointmentsMaster array to list.txt
      const jsStr = JSON.stringify(this.appointmentsMaster, null, 2).replace(/"([^"]+)":/g, "$1:");
      const blob = new Blob([jsStr], {
        type: "text/plain",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "list.txt";
      a.click();
      URL.revokeObjectURL(url);
    },
    async getPatientListFromSchedule() {
      // console.log("getPatientListFromSchedule");
      // console.log(this.patientListFromSchedule);

      const result = await fetchPatientListFromSchedule();

      if (result.ok && result.payload) {
        this.patientListFromSchedule = result.payload;
        // console.log("this.patientListFromSchedule");
        // console.log(this.patientListFromSchedule);
        return result;
      }
      return result;
    },
    async getPatientMasterList() {
      // console.log("getPatientMasterList");
      // console.log(this.masterPatientList);

      const result = await fetchPatientMasterList();

      if (result.ok && result.payload) {
        this.masterPatientList = result.payload;
        // console.log("this.masterPatientList");
        // console.log(this.masterPatientList);
        // console.log("this.masterPatientList.length");

        this.unfilteredMasterPatientList = result.payload;

        // & nextAppointment Filters  01/01/1900
        // ! charliie adams   27734
        // this.masterPatientList = this.masterPatientList.filter((x) => x.nextAppointment !== "1900-01-01T00:00:00Z");

        // console.log("list  masterPatientList: ", this.masterPatientList?.length);

        // this.patientIDStartList.forEach((patientId) => {
        //   const foundPatientIndex = this.masterPatientList.findIndex((patient) => patient.personID === patientId);
        //   if (foundPatientIndex !== -1) {
        //     const foundPatient = this.masterPatientList[foundPatientIndex];
        //     console.log("Found patient:", foundPatient);

        //     console.log(" TURN OFF  splice of masterPatientList ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++");
        //     // this.masterPatientList.splice(foundPatientIndex, 1);
        //     // this.scheduledPatients.push({ ...foundPatient, isScheduledTEMP: true, fromMaster: true });
        //   }
        // });

        return result;
      }
      return result;
    },

    // &^  Builds Patient Obj Array from User's Session Data  patientIdStartList
    async getTodaysPatientList() {
      // console.log("getTodaysPatientList");
      // console.log(this.masterPatientList);
      const result = await fetchTodaysPatientList();

      if (result.ok && result.payload) {
        this.todaysPatientList = result.payload;
        // console.log("this.todaysPatientList");
        // console.log(this.todaysPatientList);

        // foreach patient in todaysPatientList
        this.todaysPatientList.forEach((patient) => {
          // this.scheduledPatients.push({ ...patient, isScheduledTEMP: true, fromToday: true });
          // console.log("  Assinging Patient " + patient.personID + " to Users Scheduled Patients");
          this.assignTodaysPatient(patient.personID);
        });

        // this.scheduledPatients = result.payload;
        // console.log("ADDING   users todaysPatList to this.scheduledPatients");
        // console.log(this.scheduledPatients);

        return result;
      }
      return result;
    },
    async getTodaysPatientListNEW() {
      // console.log("                           getTodaysPatientListNEW                  ");
      // console.log(this.masterPatientList);
      const result = await fetchTodaysPatientList(this.patientIDStartList);

      if (result.ok && result.payload) {
        this.todaysPatientList = result.payload;
        // console.log("this.todaysPatientList");
        // console.log(this.todaysPatientList);

        // // foreach patient in todaysPatientList
        // this.todaysPatientList.forEach((patient) => {
        //   // this.scheduledPatients.push({ ...patient, isScheduledTEMP: true, fromToday: true });
        //   console.log("  Assinging Patient " + patient.personID + " to Users Scheduled Patients");
        //   this.assignTodaysPatient(patient.personID);
        // });

        // // this.scheduledPatients = result.payload;
        // console.log("ADDING   users todaysPatList to this.scheduledPatients");
        // console.log(this.scheduledPatients);

        return result;
      }
      return result;
    },

    assignMasterPatient(patientId, isScheduled) {
      const patient = this.masterPatientList.find(p => p.personID === patientId);
      if (patient) {
        patient.addToSchedule = true;
        patient.isScheduledTEMP = true;
        if (isScheduled) {
          this.scheduledPatients.push({
            ...patient,
            isScheduledTEMP: true,
            fromSchedule: true,
          });
        } else {
          this.scheduledPatients.push({
            ...patient,
            isScheduledTEMP: true,
            fromMaster: true,
          });
        }

        // Remove from unassigned
        // this.masterPatientList = this.masterPatientList.filter((p) => p.personID !== patientId);
        // add boolean to disable the created ADD btn

        // Add to assigned
      }
    },
    unassignMasterPatient(patientId) {
      const patient = this.scheduledPatients.find(p => p.personID === patientId);
      if (patient) {
        // Remove from scheduled patients
        this.scheduledPatients = this.scheduledPatients.filter(p => p.personID !== patientId);

        // Find and update the patient in masterPatientList
        const masterPatient = this.masterPatientList.find(p => p.personID === patientId);
        if (masterPatient) {
          masterPatient.addToSchedule = false;
          masterPatient.isScheduledTEMP = false;
        }
      }
    },
    assignScheduledPatient(patientId) {
      const patient = this.masterPatientList.find(p => p.personID === patientId);
      if (patient) {
        patient.addToSchedule = true;
        // Remove from unassigned
        // this.patientListFromSchedule = this.patientListFromSchedule.filter((p) => p.personID !== patientId);
        // Add to assigned
        // this.scheduledPatients.push({ ...patient, isScheduledTEMP: true, fromSchedule: true });
        this.scheduledPatients.push({ ...patient });
      }
    },
    unassignScheduledPatient(patientId) {
      const patient = this.scheduledPatients.find(p => p.personID === patientId);
      if (patient) {
        // Remove from assigned
        this.scheduledPatients = this.scheduledPatients.filter(p => p.personID !== patientId);
        // Add to unassigned
        this.patientListFromSchedule.push({
          ...patient,
          isScheduledTEMP: false,
          fromSchedule: false,
        });
      }
    },
    assignTodaysPatient(patientId) {
      const patient = this.todaysPatientList.find(p => p.personID === patientId);
      if (patient) {
        // Remove from unassigned
        this.todaysPatientList = this.todaysPatientList.filter(p => p.personID !== patientId);
        // Add to assigned
        this.scheduledPatients.push({
          ...patient,
          isScheduledTEMP: true,
          fromToday: true,
        });
      }
    },
    unassignTodaysPatient(patientId) {
      const patient = this.scheduledPatients.find(p => p.personID === patientId);
      if (patient) {
        // Remove from assigned
        this.scheduledPatients = this.scheduledPatients.filter(p => p.personID !== patientId);
        // Add to unassigned
        this.todaysPatientList.push({
          ...patient,
          isScheduledTEMP: false,
          fromToday: false,
        });
      }
    },
    setUsersPatientIdList(list) {
      // console.log("                                          USER Pat store   setUsersPatientIdList");
      // console.log(list);
      this.patientIDStartList = list;
    },
    addCurrentPatient(patient) {
      this.patientList.push({
        patient,
        id: patient.personID,
        currentPatient: false,
      });

      patient.isScheduledTEMP = true; // Manually set isScheduled to true
      // & new patient list FLAT
      this.flatPatientList.push(patient);
      // Add to assigned

      // this.flatPatientList.push({ ...patient, isScheduled: true }); // &  isScheduled: (In-memory property)

      // console.log(" ***  isScheduled *** MANUALLY ADDED to PATIENT  ");

      // console.log("this.flatPatientList");
      // console.dir(this.flatPatientList);

      // &^ Scheduled Patients
      this.scheduledPatients = this.flatPatientList.filter(p => p.isScheduledTEMP); // &  TEMPORARY property  :  isScheduledTEMP

      // const workListStore = useStoreWorkList();
      // ! TODO
      // this.unassignedScheduledPatients = fetchPatientListFromSchedule(); //this.flatPatientList.filter((p) => !p.isScheduledTEMP);
      // this.unassignedScheduledPatients = workListStore.primaryWidgetSummaryList[0]?.widgetGridDataArray;

      this.unassignedScheduledPatients = this.masterPatientList.filter(p => !p.isAssigned);
      // console.log("this.unassignedScheduledPatients");
      // console.log(this.unassignedScheduledPatients);

      // After fetching, populate the separate arrays
      this.unassignedPatients = this.patientList.filter(p => !p.isAssigned);
      this.assignedPatients = this.patientList.filter(p => p.isAssigned);

      // const tTest =  JSON.stringify(JSON.parse(this.patientList))
      //  consol   e.log(' CLONe for CONTROLs  this.patientArrayForControls = this.patientList')
      this.patientArrayForControls = this.patientList;
      // console.log('this.patientList')
      // console.log(this.patientList)
      // console.log('this.patientArrayForControls')
      // console.log(this.patientArrayForControls)
    },

    updatePatient(patient) {
      // console.log(' updatePatient    Patient    id > ')
      const index = this.patientList.findIndex(obj => obj.id === patient.id);
      if (index !== -1) {
        this.patientList[index] = {
          ...this.patientList[index],
          ...patient,
        };
      }
    },
    deletePatient(itemID) {
      // console.log(' DELETE Patient    id > ')
      // console.log(itemID)
      this.patientList = this.patientList.filter(object => object.id !== itemID);
    },
    toggleCurrent(idToFind) {
      // console.log(' toggleCurrent    Patient    idToFind > ')
      // console.log(idToFind)

      const todo = this.patientList.find(obj => obj.id === idToFind);
      if (todo) {
        todo.currentPatient = !todo.currentPatient;
      }
    },
    // store NEW Mutation
    addPatientToArray(patient) {
      // console.log("***STORE SETTER ***********");
      // console.log(patient);
      // console.log("<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<");
      this.patientArrayForControls.push(patient);
    },
  },
});
